<template>
  <el-dialog title="" v-model="show" size="tiny" custom-class="embassy-holiday-modal" :modal-append-to-body="true" @close="close" :show-close="false" top="50%">
    <div class="embassy-holiday-header" slot="title">
      <div class="embassy-holiday-title">使馆放假日历</div>
      <div class="embassy-holiday-tips">
        <div class="weekend-tips">周末休息</div>
        <div class="embassy-tips">使馆放假</div>
      </div>
      <div class="header-close" @click="close">
        <i class="el-icon-close" />
      </div>
    </div>
    <div class="embassy-holidy-view">
      <div class="pre-month" @click.stop="switchMonth(0)"></div>
      <!-- 日历内容 -->
      <div class="body">
        <div class="date-list-box">
          <div class="date-bg-month">{{nowDisplayMonth}}</div>
          <div class="date-list-title">
            <!-- 当前月份 -->
          <div class="current-year-month">{{ nowDisplayYear }}年{{ nowDisplayMonth }}月</div>
          </div>
          <!-- 周几列表 -->
          <div class="date-list-week">
            <span v-for="week in weekdayForShort" :key="week">{{ week }}</span>
          </div>

          <!-- 日期列表 -->
          <div class="date-list-day">
            <div class="date-day-item-box" v-for="(date, index) in totalDates" :key="index">
              <span class="inner-text" :class="{ 'holiday': date.holiday, 'weekend': date.weekend, disabled: date.disabled}">{{ date.text }}</span>
            </div>
          </div>
        </div>
        <div class="date-list-box">
          <div class="date-bg-month">{{nextMonth}}</div>
          <div class="date-list-title">
            <!-- 当前月份 -->
          <div class="current-year-month">{{ nextYear }}年{{ nextMonth }}月</div>
          </div>
          <!-- 周几列表 -->
          <div class="date-list-week">
            <span v-for="week in weekdayForShort" :key="week">{{ week }}</span>
          </div>

          <!-- 日期列表 -->
          <div class="date-list-day">
            <div class="date-day-item-box" v-for="(date, index) in nextTotalDates" :key="index">
              <span class="inner-text" :class="{ 'holiday': date.holiday, 'weekend': date.weekend, disabled: date.disabled}">{{ date.text }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="next-month" @click.stop="switchMonth(1)"></div>
    </div>
  </el-dialog>
</template>

<script>
import DateUtil from '../../../libs/date-util';

export default {
  name: 'embassy-holiday-view',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    holidayDateArr: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      show: false,
      weekdayForShort: {
        0: '日',
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
      },

      nowDisplayYear: '', // 控件当前显示的日期
      nowDisplayMonth: '',
      nowMonthArr: [], // 控件当前显示的月份数组
      paddingMonthDates: [], // 补一些空的日期对象，占位

      nextMonthArr: [],
      paddingNextMonthDates: [],

      todayDateStr: DateUtil.getBaseDate(new Date()),
      todayTimemiles: new Date().getTime(),
    };
  },
  computed: {
    totalDates() {
      return [...this.paddingMonthDates, ...this.nowMonthArr];
    },
    nextTotalDates() {
      return [...this.paddingNextMonthDates, ...this.nextMonthArr];
    },
    nextYear() {
      return this.getNextOrPreMonth(this.nowDisplayYear, this.nowDisplayMonth, 1).year;
    },
    nextMonth() {
      return this.getNextOrPreMonth(this.nowDisplayYear, this.nowDisplayMonth, 1).month;
    },
  },
  watch: {
    holidayDateArr(val) {
      if (val) {
        this.init();
      }
    },
    value(newVal) {
      this.show = newVal;
      if (newVal) {
        this.init();
      }
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 当前年份
      this.nowDisplayYear = new Date().getFullYear();
      // 当前月份
      this.nowDisplayMonth = new Date().getMonth() + 1;
      this.initHolidayData();
    },

    // 初始化假期数据
    initHolidayData() {
      if (this.holidayDateArr) {
        this.setCalender();
      }
    },

    // 创建当前月份的日期数组
    createCurrentMonthDates(year, month) {

      // 当前这个月有多少天
      const calenderDatesLength = new Date(year, month, 0).getDate();

      // 当前月份的日期数组
      const calenderDates = [];

      let i = 0;
      while (i < calenderDatesLength) {
        const date = new Date(year, month - 1, i + 1);
        const dateStr = DateUtil.getBaseDate(date);
        calenderDates.push(this.createDisplayDate({ dateStr, timemile: date.getTime(), text: i + 1 }));
        i++;
      }

      return calenderDates;
    },

    // 创建一个日期对象
    createDisplayDate({ dateStr = '', timemile = 0, text = '' } = {}) {
      return {
        disabled: true,
        date: dateStr,
        timemile,
        text,
        weekend: false,
        holiday: false,
      };
    },

    // 设置当前月份，年份，天数
    setCalender() {
      this.nowMonthArr = this.generateSingeCalender(this.nowDisplayYear, this.nowDisplayMonth);
      this.paddingMonthDates = this.addPaddingMonthDates(this.nowMonthArr);

      // 生成下一个月的数据
      this.nextMonthArr = this.generateSingeCalender(this.nextYear, this.nextMonth);
      this.paddingNextMonthDates = this.addPaddingMonthDates(this.nextMonthArr);
    },

    generateSingeCalender(year, month) {
      const me = this;
      const calenderDates = this.createCurrentMonthDates(year, month);

      calenderDates.forEach((dateDisplay) => {
        dateDisplay.disabled = me.todayTimemiles > dateDisplay.timemile;
        me.holidayDateArr.forEach((holidayDateItem) => {
          const holidayDateStr = DateUtil.getBaseDate(new Date(holidayDateItem.date));
          if (holidayDateStr === dateDisplay.date) {
            dateDisplay.weekend = holidayDateItem.dayText === '休';
            dateDisplay.holiday = holidayDateItem.dayText === '假';
          }
        });
      });

      return calenderDates;
    },

    // 使用空的日期对象填上月份前面的空日期，这样就不用很麻烦的算就margin-left了
    addPaddingMonthDates(calenderDates) {
      const paddingDates = [];
      const monthFirstDay = new Date(calenderDates[0].date).getDay();
      for (let i = 0; i < monthFirstDay; i++) {
        paddingDates.push(this.createDisplayDate());
      }
      return paddingDates;
    },

    // 切换月份，0减少月份，1增加月份
    switchMonth(direction) {
      const { month, year } = this.getNextOrPreMonth(this.nowDisplayYear, this.nowDisplayMonth, direction);
      this.nowDisplayMonth = month;
      this.nowDisplayYear = year;
      this.setCalender();
    },
    getNextOrPreMonth(year, month, direction) {

      const nextYear = month === 12 && direction === 1;
      const preYear = month === 1 && direction === 0;

      // 跨年
      if (nextYear || preYear) {

        // 后一年一个月
        if (nextYear) {
          month = 1;
          year += 1;
        } else {

          // 前一年一个月
          month = 12;
          year -= 1;
        }
      } else {

        // 未跨年

        // 月份切换
        if (direction === 1) {

          // 后一月
          month += 1;
        } else if (direction === 0) {

          // 前一月
          month -= 1;
        }
      }
      return { year, month };
    },
    // 关闭
    close() {
      this.show = false;
      this.$emit('input', false);
    },
  },

};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";
 /deep/ .embassy-holiday-modal{
   width: 606px;
   min-height: 334px;
   transform: translate(-50%,-50%);
  .el-dialog__header{
    padding: 0;
    .embassy-holiday-header{
      flex-grow: 1;
      height: 60px;
      display: flex;
      align-items: center;
      padding: 0 24px;
      line-height: 1;
      border-bottom: 1px solid #E9EEF2;
      .embassy-holiday-title{
        color: #2F333D;
        font-size: 20px;
        font-weight: 600;
      }
      .embassy-holiday-tips{
        flex-grow: 1;
        display: flex;
        align-items: center;
        margin-left: 16px;
        .weekend-tips, .embassy-tips{
          font-size: 12px;
          color: #2F333D;
          display: flex;
          align-items: center;
          margin-right: 12px;
          &::before{
            content: "";
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-right: 2px;
          }
        }
        .weekend-tips{
          &::before{
            background: #599FFF;
          }
        }
        .embassy-tips{
          &::before{
            background: #FF5A60;
          }
        }

      }
      .header-close{
        color: #91999F;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
  .el-dialog__body{
    padding: 0;
  }
}
.embassy-holidy-view{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 10px;
  .pre-month{
    cursor: pointer;
    width: 32px;
    height: 32px;
    background: url(../../../assets/imgs/product-detail/calendar-left-1.png) no-repeat center / 100% 100%;
    &:hover{
      background: url(../../../assets/imgs/product-detail/calendar-left-hover-1.png) no-repeat center / 100% 100%;
    }
  }
  .body{
    display: flex;
    .date-list-box{
      width: 240px;
      height: 242px;
      flex-shrink: 0;
      position: relative;
      z-index: 1;
      &:last-child{
        margin-left: 28px;
      }
      .date-bg-month{
        font-size: 100px;
        position: absolute;
        left: 50%;
        top: 65px;
        transform: translate(-50%, 0);
        color:#599FFF;
        opacity: 0.1;
        z-index: -1;

      }
      .date-list-title{
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
        .current-year-month{
          color: #2F333D;
          font-size: 12px;
          font-weight: 600;
        }
      }
      .date-list-week {
        font-size: 12px;
        padding: 0 15px;
        color: #2F333D;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
      .date-list-day {
        display: flex;
        flex-wrap: wrap;
        padding: 10px 15px;
        .date-day-item-box {
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          .inner-text {
            color: #2F333D;
            font-size: 12px;
            line-height: 12px;
            width: 22px;
            height: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 100%;
            background-color: transparent;
            &.weekend {
              background-color: #599FFF;
              color: white;
            }
            &.holiday {
              background-color: #FF5A60;
              color: white;
            }
            &.disabled {
              color: #CFCFCF;
            }
          }
        }
      }
    }
  }

  .next-month{
    cursor: pointer;
    width: 32px;
    height: 32px;
    transform: rotate(180deg);
    background: url(../../../assets/imgs/product-detail/calendar-left-1.png) no-repeat center / 100% 100%;
    &:hover{
      background: url(../../../assets/imgs/product-detail/calendar-left-hover-1.png) no-repeat center / 100% 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/country/components/embassy-holiday-view.vue